var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[(_vm.$scopedSlots.before)?_vm._t("before"):_vm._e(),_vm._t("navigation"),(_vm.$scopedSlots.after)?_vm._t("after"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }